export default __webpack_public_path__ + "static/homepage-blueprints-8657ba83c64303113e02dacd368697c0.png";